import type { CentrifugeMessage } from '../messageTypes';

type SecondInString = `${number}`;
type AvailableType = 'png' | 'webp';

interface HeartIconVIPMessageMessage {
  type: AvailableType;
  sec: SecondInString;
  url: string;
}

export interface HeartIconVIPMessageUnparsed {
  data: {
    type: 'HeartIconVip';
    message: string;
    created_at?: number;
  };
  offset: number;
}

export interface HeartIconVIPMessage {
  data: {
    type: 'HeartIconVip';
    message: {
      pc: HeartIconVIPMessageMessage;
      mp: HeartIconVIPMessageMessage;
      ml: HeartIconVIPMessageMessage;
    }[];
    created_at?: number;
  };
  offset: number;
}

export const isHeartIconVipMessage = (item: CentrifugeMessage): item is HeartIconVIPMessage => {
  return 'data' in item && item.data.type === 'HeartIconVip';
};
